function infopageController($translate, $scope, coreService, $sce) {
  // Assign this controller as the view-model.
    // It will be accessible as 'infopageController' within the HTML template.
    var vm = this;
    vm.messages = [];
    vm.title = "";
    vm.infoDetails = "";
    $scope.formatInfo = formatInfo;
    // Activate the controller.
    activate();
  
    // Activates the controller.
    function activate() {
      var model = coreService.getIdentityModel();
      // Read Identity Server's data model
      $scope.model = model;
  
      // Change display language
      if (model && model.ui_locales) {
          $translate.preferredLanguage(model.ui_locales);
      }
  
      if (model.infoMessage){

        var str = '<a href="' + model.oidcProviderUrl + '">' + model.oidcProvider + '</a>'
        vm.messages.push(model.infoMessage + ' ' + str + '.');       

        vm.title = model.infoTitle;
        vm.infoDetails =  model.infoMessage;
      }
    }
  
    function formatInfo(message){
      return $sce.getTrustedHtml(replaceAll(message, "\n", "<br>"));
    };  
  
    function replaceAll(str, find, replace) {
      return str.replace(new RegExp(find, 'g'), replace);
    }    
  }
  
  export default infopageController;
  


// WEBPACK FOOTER //
// ./src/infopage/infopage.controller.js